import { hasLocizeTranslation } from 'lib/utils/locize'

const labels = {
  title: ['Diamond membership', 'สมาชิก Diamond'],
  intro: ['More from every purchase', 'คุ้มค่ามากขึ้นทุกครั้งที่ช้อป'],
  view: ['View all member benefits', 'ดูสิทธิประโยชน์สมาชิกทั้งหมด'],
  add: ['Add membership', 'เพิ่มสมาชิก'],
  adding: ['Adding membership…', 'กำลังเพิ่มสมาชิก…'],
  close: [
    'Close benefits and return to bag',
    'ปิดสิทธิประโยชน์และกลับไปที่ถุงช้อปปิ้ง',
  ],
  back: ['Back to bag', 'กลับไปที่ถุงช้อปปิ้ง'],
  more: ['More member benefits', 'สิทธิประโยชน์สมาชิกเพิ่มเติม'],
  eligibility: ['Eligibility & benefit terms', 'เงื่อนไขการรับสิทธิประโยชน์'],
  eligibilityBody: [
    'The 8% saving applies to eligible items. Membership and voucher terms apply. Cashback is separate from the 8% discount.',
    'ส่วนลด 8% ใช้ได้กับสินค้าที่ร่วมรายการ เป็นไปตามเงื่อนไขสมาชิกและคูปอง เครดิตเงินคืนเป็นสิทธิประโยชน์แยกจากส่วนลด 8%',
  ],
  terms: [
    'Membership, renewal & cancellation',
    'การเป็นสมาชิก การต่ออายุ และการยกเลิก',
  ],
  error: [
    'We couldn’t confirm that membership was added. Check your bag before trying again.',
    'ยังยืนยันการเพิ่มสมาชิกไม่ได้ โปรดตรวจสอบถุงช้อปปิ้งก่อนลองอีกครั้ง',
  ],
  unavailable: [
    'Membership details are unavailable. Please try again later.',
    'ไม่สามารถแสดงรายละเอียดสมาชิกได้ โปรดลองอีกครั้งภายหลัง',
  ],
  added: ['Membership added to your bag.', 'เพิ่มสมาชิกในถุงช้อปปิ้งแล้ว'],
  renewal: [
    'Renews annually unless cancelled.',
    'ต่ออายุอัตโนมัติทุกปีหากไม่ยกเลิก',
  ],
}

export const memberCopy = (t, language, name) =>
  hasLocizeTranslation(
    t,
    `CART_DIAMOND_${name.toUpperCase()}`,
    labels[name][language === 'th' ? 1 : 0],
  )

export const getConfiguredText = (t, key) => {
  const value = hasLocizeTranslation(t, key, '')
  if (typeof value !== 'string') return ''
  const visibleText = value
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;|&#xa0;/gi, ' ')
    .trim()
  return visibleText ? value.trim() : ''
}

export const getConfiguredBenefits = (t, loyaltyData) =>
  (loyaltyData.summary_benefits || [])
    .map((benefit) => ({
      ...benefit,
      text: getConfiguredText(t, benefit.title_key),
    }))
    .filter((benefit) => benefit.text)

// Only the Thailand offer has approved, verified copy for these three benefits.
// Other shops retain the benefits and translations supplied by their configuration.
export const getHighlights = (t, language, shop, benefits) => {
  if (shop !== 'th') return benefits
  const thai = language === 'th'
  const approved = [
    {
      key: 'DIAMOND_EXCLUSIVE_DISCOUNT',
      label: 'DISCOUNT',
      lead: thai ? 'ประหยัด 8%' : 'Save 8%',
      tail: thai
        ? ' สำหรับสินค้าที่ร่วมรายการในการซื้อครั้งต่อ ๆ ไป'
        : ' on all eligible future purchases',
    },
    {
      key: 'DIAMOND_EXCLUSIVE_VOUCHER',
      label: 'MONTHLY_VOUCHER',
      lead: thai ? 'คูปองซื้อ 1 แถม 1' : 'Buy 1, Get 1 voucher',
      before: thai ? 'รับ' : 'Get a ',
      tail: thai ? ' ทุกเดือน' : ' every month',
    },
    {
      key: 'DIAMOND_EXCLUSIVE_CASHBACK',
      label: 'CASHBACK',
      lead: thai ? 'เครดิตเงินคืน 11%' : '11% cashback',
      before: thai ? 'รับ' : 'Earn ',
    },
  ]
  return approved
    .filter(({ key }) => benefits.some(({ title_key }) => title_key === key))
    .map(({ key, label, lead, before = '', tail = '' }) => ({
      title_key: key,
      icon_url_blue: benefits.find(({ title_key }) => title_key === key)
        .icon_url_blue,
      before: hasLocizeTranslation(t, `CART_DIAMOND_${label}_BEFORE`, before),
      lead: hasLocizeTranslation(t, `CART_DIAMOND_${label}_LEAD`, lead),
      tail: hasLocizeTranslation(t, `CART_DIAMOND_${label}_AFTER`, tail),
    }))
}
